import { useAuth } from 'hooks/auth';
import { applyQueryString, api } from 'services';

export function useStock() {
  const { token } = useAuth();

  const getStocks = async (filters: any): Promise<any> => {
    const url = applyQueryString(`/stocks`, {
      ...filters.formFilter,
      stockType: filters.statusFilter.join(','),
    });

    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  const getPendingStocks = async (filters: any): Promise<any> => {
    const url = applyQueryString(`/stocks`, {
      ...filters.formFilter,
    });

    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    //percorrer filtros para filtrar os dados pelo status, sendo que pode ser mais de um status
    let filteredData: any = [];
    for (let i = 0; i < filters.statusFilter.length; i++) {
      filteredData = [
        ...filteredData,
        ...data.filter((item: any) => item.status === filters.statusFilter[i]),
      ];
    }

    return filteredData;
  };

  return { getStocks, getPendingStocks };
}
